<template>
    <div>
        <div v-if="form_data.matrices_unidades[0].activo">
            <v-row v-for="(item, index) in alimentosSelect" :key="item.id">
                <v-col cols="12" md="6" >
                    <v-select
                    :items="listaAlimentos"
                    v-model="item.alimentos_id"
                    item-text="alimento"
                    item-value="id"
                    label="ALIMENTOS"
                    outlined
                    dense
                    multiple="multiple"
                    @blur="onChange($event)"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="4" >
                    <v-text-field
                    name="umbral"
                    type="number"
                    v-model="item.umbral"
                    label="UMBRAL"
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" >
                    <v-btn
                      x-small class="ma-2"
                      v-if="index==0" outlined fab color="teal"
                      v-on:click="additemAlimento()"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                      x-small class="ma-2"
                      v-if="index>0" outlined fab
                      color="error" v-on:click="deleteitemUmbral(index,'A')"
                      >
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <div v-if="form_data.matrices_unidades[1].activo">
            <v-row v-for="(item, index) in superficiesSelect" :key="item.zona">
                <v-col cols="12" md="6" >
                    <v-select
                    :items="listaSuperficies"
                    v-model="item.zonas"
                    item-text="zona"
                    item-value="id"
                    label="SUPERFCIES"
                    outlined
                    dense
                    @blur="onChangesuperficie($event)"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="2" >
                    <v-text-field
                    name="umbral"
                    type="number"
                    label="UMBRAL CRITICA"
                    outlined
                    dense
                    v-model="item.umbral_critico"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" >
                    <v-text-field
                    name="umbral"
                    type="number"
                    label="UMBRAL NO CRITICA"
                    outlined
                    dense
                    v-model="item.umbral_nocritico"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" >
                    <v-btn x-small class="ma-2" v-if="index==0"
                    outlined fab color="teal" v-on:click="additemSuperficie()">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn x-small class="ma-2" v-if="index>0"
                      outlined fab color="error" v-on:click="deleteitemUmbral(index,'S')">
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <div v-if="form_data.matrices_unidades[2].activo">
            <v-row v-for="(item, index) in manipuldoresSelect" :key="'M'+item.id">
                <v-col cols="12" md="6" >
                    <v-select
                    :items="listaManipuladores"
                    v-model="item.manipulador"
                    item-text="value"
                    item-value="id"
                    label="MANIPULADORES"
                    outlined
                    dense
                    multiple="multiple"
                    @blur="onChangemanupulador($event)"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="4" >
                    <v-text-field
                    name="umbral"
                    type="number"
                    label="UMBRAL"
                    outlined
                    dense
                    v-model="item.umbral"
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" >
                    <v-btn x-small class="ma-2" v-if="index==0"
                    outlined fab color="teal" v-on:click="additemManipuladores()">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn x-small class="ma-2" v-if="index>0"
                      outlined fab color="error" v-on:click="deleteitemUmbral(index,'M')">
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <div v-if="form_data.matrices_unidades[3].activo">
            <v-row v-for="(item, index) in aguasSelect" :key="'W'+item.id">
                <v-col cols="12" md="6" >
                    <v-select
                    :items="listaAguas"
                    v-model="item.aguas"
                    item-text="value"
                    item-value="id"
                    label="AGUAS"
                    outlined
                    dense
                    multiple="multiple"
                    @blur="onChangeaguas($event)"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="4" >
                    <v-text-field
                    name="umbral"
                    type="number"
                    label="UMBRAL"
                    v-model="item.umbral"
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" >
                    <v-btn x-small class="ma-2" v-if="index==0"
                    outlined fab color="teal" v-on:click="additemAguas()">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn x-small class="ma-2" v-if="index>0"
                      outlined fab color="error" v-on:click="deleteitemUmbral(index,'W')">
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>

        <div v-if="form_data.matrices_unidades[4].activo">
            <v-row v-for="(item, index) in ambientesSelect" :key="'E'+item.id">
                <v-col cols="12" md="6" >
                    <v-select
                    :items="listaAmbiente"
                    v-model="item.ambiente"
                    item-text="value"
                    item-value="id"
                    label="AMBIENTES"
                    outlined
                    dense
                    multiple="multiple"
                    @blur="onChangeambientes($event)"
                    ></v-select>
                </v-col>
                <v-col cols="12" md="4" >
                    <v-text-field
                    name="umbral"
                    type="number"
                    label="UMBRAL"
                    v-model="item.umbral"
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="12" md="2" >
                    <v-btn x-small class="ma-2" v-if="index==0"
                    outlined fab color="teal" v-on:click="additemAmbientes()">
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn x-small class="ma-2" v-if="index>0"
                      outlined fab color="error" v-on:click="deleteitemUmbral(index,'E')">
                        <v-icon>mdi-minus</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </div>

    </div>
</template>

<script>
/* eslint-disable */
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Umbrales',
  data: () => ({
    alimentosSelect: [
      {
        id: 0,
        alimentos_id: [],
        umbral: 0,
      },
    ],
    superficiesSelect: [
      {
        id: 0,
        zonas: [],
        umbral_critico: 0,
        umbral_nocritico: 0,
      },
    ],
    manipuldoresSelect: [
      {
        id: 0,
        manipulador: [],
        umbral: 0,
      },
    ],
    aguasSelect: [
      {
        id: 0,
        aguas: [],
        umbral: 0,
      },
    ],
    ambientesSelect: [
      {
        id: 0,
        ambiente: [],
        umbral: 0,
      },
    ],
    listaAlimentos: [
      {
        id: 0,
        alimento: 'Helados',
        active: true,
      },
      {
        id: 1,
        alimento: 'Leche',
        active: true,
      },
      {
        id: 2,
        alimento: 'Productos gaseosos',
        active: true,
      },
      {
        id: 3,
        alimento: 'Caldos',
        active: true,
      },
      {
        id: 4,
        alimento: 'Azucares',
        active: true,
      },
    ],
    listaSuperficies: [
      {
        id: 1,
        zona: 'Zona 1',
      },
      {
        id: 2,
        zona: 'Zona 2',
      },
      {
        id: 3,
        zona: 'Zona 3',
      },
    ],
    listaManipuladores: [
      {
        id: 0,
        value: 'Manos',
      },
      {
        id: 1,
        value: 'Nariz',
      },
      {
        id: 2,
        value: 'Boca',
      },
      {
        id: 3,
        value: 'Manos limpias',
      },
      {
        id: 4,
        value: 'Con guantes',
      },
    ],
    listaAguas: [
      {
        id: 0,
        value: 'Hielo',
      },
      {
        id: 1,
        value: 'Agua',
      },
    ],
    listaAmbiente: [
      {
        id: 0,
        value: 'En proceso',
      },
      {
        id: 1,
        value: 'Limpio',
      },
    ],
    form_dataens: {
      data_ensayo: {
        alimentosUmbral: [],
      },
    },

  }),
  beforeCreate() {
    // axios.get('/getPatList').then((response) => {
      // this.desserts = response.data;
      // console.log(this.desserts);
    // });
  },
  computed: {
    ...mapState('Ensayos', ['form_data']),
  },
  methods: {
    ...mapMutations('Ensayos', ['setPatSelected', 'setState']),
    edit_tecnica_pat(enabled, id_pat) {
      let found = false;
      this.form_data.patogenos_selected.map((v) => {
        if (v.cod_pat === id_pat.cod_pat) { found = true; }
      });
      // console.log([this.form_data.patogenos_selected , id_pat.cod_pat ] );
      if (found) {
        this.dialog = enabled;
        this.setPatSelected(id_pat);
      } else if (!found) {
        this.snackbar = true;
      }
    },
    clear() {
      this.dialog = false;
      // setPatSelected(null);
    },
    additemAlimento() {
      const id = this.alimentosSelect.length + 1;
      this.alimentosSelect.push({
        id,
        alimentos_id: [],
        umbral: 0,
      });
    },
    deleteitemUmbral(index, matriz) {
      console.log(index, matriz);
      switch (matriz) {
        case 'A':
          this.alimentosSelect.splice(index, 1);
          break;
        case 'S':
          this.superficiesSelect.splice(index, 1);
          break;
        case 'M':
          this.manipuldoresSelect.splice(index, 1);
          break;
        case 'W':
          this.aguasSelect.splice(index, 1);
          break;
        case 'E':
          this.ambientesSelect.splice(index, 1);
          break;
      }
    },
    additemSuperficie() {
      const id = this.superficiesSelect.length + 1;
      if (this.superficiesSelect.length == 3) {
        return false;
      }
      this.superficiesSelect.push({
        id,
        zonas: [],
        umbral_critico: 0,
        umbral_nocritico: 0,
      });
    },

    onChange(ev) {
      const list = [];
      const selects = this.alimentosSelect;
      selects.forEach((element) => {
        const arrayid = element.alimentos_id;
        for (let i = 0; i < arrayid.length; i++) {
          list.push(arrayid[i]);
        }
      });
      // FILTRO LOS DATOS YA SELECCIONADOS
      const restan = [];
      this.listaAlimentos.map((v) => {
        if (list.includes(v.id) == false) {
          restan.push(v);
        }
      });
      this.listaAlimentos = restan;
    },
    onChangesuperficie(ev) {
      const list = [];
      const selects = this.superficiesSelect;
      console.log(selects);
      selects.forEach((element) => {
        const arrayid = element.zonas;
        // for (let i = 0; i < arrayid.length; i++) {
        list.push(arrayid);
        // }
      });
      // FILTRO LOS DATOS YA SELECCIONADOS
      const restan = [];
      this.listaSuperficies.map((v) => {
        if (list.includes(v.id) == false) {
          restan.push(v);
        }
      });
      console.log(restan);
      this.listaSuperficies = restan;
    },
    additemManipuladores() {
      const id = this.manipuldoresSelect.length + 1;
      this.manipuldoresSelect.push({
        id,
        manipulador: [],
        umbral: 0,
      });
    },
    onChangemanupulador(ev) {
      const list = [];
      const selects = this.manipuldoresSelect;
      console.log(selects);
      selects.forEach((element) => {
        const arrayid = element.manipulador;
        for (let i = 0; i < arrayid.length; i++) {
          list.push(arrayid[i]);
        }
      });
      // FILTRO LOS DATOS YA SELECCIONADOS
      const restan = [];
      this.listaManipuladores.map((v) => {
        if (list.includes(v.id) == false) {
          restan.push(v);
        }
      });
      console.log(restan);
      this.listaManipuladores = restan;
    },
    additemAguas() {
      if (this.aguasSelect.length == 2) {
        return false;
      }
      const id = this.aguasSelect.length + 1;
      this.aguasSelect.push({
        id,
        aguas: [],
        umbral: 0,
      });
    },
    onChangeaguas(ev) {
      const list = [];
      const selects = this.aguasSelect;
      console.log(selects);
      selects.forEach((element) => {
        const arrayid = element.aguas;
        for (let i = 0; i < arrayid.length; i++) {
          list.push(arrayid[i]);
        }
      });
      // FILTRO LOS DATOS YA SELECCIONADOS
      const restan = [];
      this.listaAguas.map((v) => {
        if (list.includes(v.id) == false) {
          restan.push(v);
        }
      });
      console.log(restan);
      this.listaAguas = restan;
    },
    additemAmbientes() {
      if (this.ambientesSelect.length == 2) {
        return false;
      }
      const id = this.ambientesSelect.length + 1;
      this.ambientesSelect.push({
        id,
        ambiente: [],
        umbral: 0,
      });
    },
    onChangeambientes(ev) {
      const list = [];
      const selects = this.ambientesSelect;
      console.log(selects);
      selects.forEach((element) => {
        const arrayid = element.ambiente;
        for (let i = 0; i < arrayid.length; i++) {
          list.push(arrayid[i]);
        }
      });
      // FILTRO LOS DATOS YA SELECCIONADOS
      const restan = [];
      this.listaAmbiente.map((v) => {
        if (list.includes(v.id) == false) {
          restan.push(v);
        }
      });
      console.log(restan);
      this.listaAmbiente = restan;
    },
  },
};
</script>
